export default __webpack_public_path__ + "static/media/img_publi3.221edee3.svg";